const InfoModal = ({ textHeader, textBody, id }) => {
  return (
    <div className="modal fade" id={id}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title">{textHeader}</h4>
          </div>
          <div className="modal-body">{textBody}</div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-danger"
              data-dismiss="modal"
            >
              Sulje
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoModal;
